import { ProfileMenu } from './ProfileMenu';
import { AgentSelector } from './AgentSelector';
import { teamsExperience } from '../config/teamsExperience';
import { type AgentOption } from '../config/agentOptions';
import { useIsMobile } from '../hooks/useIsMobile';

export function Header({ onNavigate, selectedAgent, onAgentChange }: {
  onNavigate: (route: string) => void;
  selectedAgent: AgentOption;
  onAgentChange: (agent: AgentOption) => void;
}) {
  const isMobile = useIsMobile();
  return (
    <header style={{ ...styles.header, ...(isMobile ? { padding: '12px 16px', gap: 8 } : {}) }}>
      <button onClick={() => onNavigate('home')} style={styles.brand}>
        <div style={styles.logo}>
          <span style={{ ...styles.logoBlock, background: '#f25022' }} />
          <span style={{ ...styles.logoBlock, background: '#7fba00' }} />
          <span style={{ ...styles.logoBlock, background: '#00a4ef' }} />
          <span style={{ ...styles.logoBlock, background: '#ffb900' }} />
        </div>
        <div style={{ minWidth: 0 }}>
          <div style={styles.brandSubtitle}>ONECONSUMER SUPPORT</div>
          <div style={{ ...styles.brandTitle, ...(isMobile ? { fontSize: 16 } : {}) }}>Consumer Support Portal</div>
        </div>
      </button>
      <nav style={styles.nav}>
        <AgentSelector selectedAgent={selectedAgent} onAgentChange={onAgentChange} />
        <button
          onClick={() => onNavigate('teams')}
          className="hover-header-btn"
          style={styles.teamsButton}
          aria-label={teamsExperience.headerButtonAriaLabel}
          title={teamsExperience.headerButtonAriaLabel}
        >
          <span style={styles.teamsIcon} aria-hidden="true">{teamsExperience.logoText}</span>
          <span>{teamsExperience.headerButtonLabel}</span>
        </button>
        <ProfileMenu onNavigate={onNavigate} />
      </nav>
    </header>
  );
}

const styles: Record<string, React.CSSProperties> = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    rowGap: 10,
    padding: '16px 32px',
    background: 'linear-gradient(135deg, #0078d4 0%, #1a5fb4 100%)',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 10,
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    color: 'white',
    textAlign: 'left',
  },
  logo: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 3,
    width: 32,
    height: 32,
  },
  logoBlock: {
    width: '100%',
    height: '100%',
    borderRadius: 1,
  },
  brandSubtitle: {
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: 1,
    opacity: 0.9,
  },
  brandTitle: {
    fontSize: 22,
    fontWeight: 700,
  },
  nav: { display: 'flex', alignItems: 'center', gap: 12 },
  teamsButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    border: '1px solid rgba(255,255,255,0.4)',
    background: 'rgba(255,255,255,0.15)',
    color: 'white',
    borderRadius: 999,
    padding: '7px 14px',
    fontWeight: 600,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  teamsIcon: {
    width: 22,
    height: 22,
    borderRadius: 6,
    display: 'inline-grid',
    placeItems: 'center',
    background: teamsExperience.theme.purpleMedium,
    color: '#fff',
    fontWeight: 700,
    fontSize: 13,
  },
};

